import { render, staticRenderFns } from "./ReadDefault.vue?vue&type=template&id=1530ed20&scoped=true&"
import script from "./ReadDefault.vue?vue&type=script&lang=js&"
export * from "./ReadDefault.vue?vue&type=script&lang=js&"
import style0 from "./ReadDefault.vue?vue&type=style&index=0&id=1530ed20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1530ed20",
  null
  
)

export default component.exports